package ir.hosen.resume.components

import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.selectors.hover
import org.jetbrains.compose.web.css.s

val LinkStyle = CssStyle {
    base {
        Modifier
            .textDecorationLine(TextDecorationLine.None)
            .transition(Transition.of("text-decoration-color", 0.3.s))
    }
    hover {
        Modifier
            .textDecorationLine(TextDecorationLine.Underline)
            .transition(Transition.of("text-decoration-color", 0.3.s))
    }
}